// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"StatusBox_infoContainer__HLBgE","success":"StatusBox_success__cNgNl","error":"StatusBox_error__BQEBM","link":"StatusBox_link__b2ylJ"};